import { Component, Inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { FIREARM_TYPE } from "assets-model";
import { FirearmAssignablePersonService, FirearmAssignmentLogService, FirearmPoolService, FirearmService, FirearmStorageLocationService } from "assets-service";
import { FirearmStorageAssignmentCreationDialogComponent, FirearmStorageAssignmentCreationDialogConfigData, FirearmStorageAssignmentCreationDialogData } from "./firearm-storage-assignment-creation-dialog.component";



export interface FirearmDisposeDialogData extends FirearmStorageAssignmentCreationDialogData {
}

export interface FirearmDisposeDialogConfigData extends FirearmStorageAssignmentCreationDialogConfigData {
}

@Component({
  selector: 'app-firearm-dispose-dialog',
  templateUrl: './firearm-dispose-dialog.component.html',
  styleUrls: ['./firearm-dispose-dialog.component.scss']
})
export class FirearmDisposeDialogComponent extends FirearmStorageAssignmentCreationDialogComponent {

  get firearmTypeName(): string {
    return FIREARM_TYPE.typeName(this.data?.firearm);
  }

  constructor(
    dialogRef: MatDialogRef<FirearmDisposeDialogComponent, FirearmDisposeDialogData>,
    @Inject(MAT_DIALOG_DATA) data: FirearmDisposeDialogConfigData,
    fb: FormBuilder,
    dialog: MatDialog,
    firearmService: FirearmService,
    firearmAssignmentLogService: FirearmAssignmentLogService,
    firearmAssignablePersonService: FirearmAssignablePersonService,
    firearmStorageLocationService: FirearmStorageLocationService,
    firearmPoolService: FirearmPoolService,
    configService: ConfigStorage,
    userStorage: UserStorage) {
    super(dialogRef, data, fb, dialog, firearmService, firearmAssignmentLogService, firearmAssignablePersonService, firearmStorageLocationService, firearmPoolService, configService, userStorage);
  }

  protected isStorageAssigneeRequired() {
    return true;
  }
  protected isLocationRequired() {
    return false;
  }
  protected isCommentRequired() {
    return true;
  }

  protected createLocationFilter(): any {
    return {
      includeNational: true,
      buId: this.data.firearm?.asset?.businessUnit?.buId,
      disposalLocation: true
    };
  }

  isFirearmDisposeEnabled() {
    return this.isFirearmStorageAssignmentCreationEnabled();
  }

  firearmDispose() {
    this.firearmService.disposeFirearm({
      assetId: this.data.firearm?.assetId,
      storageAssignee: {
        personId: this.item?.storageAssignee?.personId,
        username: this.item?.storageAssignee?.user?.user
      },
      locationId: this.item?.location?.firearmStorageLocationId,
      comments: this.item.comments
    }).subscribe(result => {
      this.item.firearm = result;
      this.dialogRef.close(this.item);
    });
  }

}
